import { getCachedViewSnapshotForSelections } from '@databases/database-state';
import { type PanelManager } from '@databases/panel-types';
import {
  buildCellActions,
  buildColumnActions,
  buildRowActions,
} from '@databases/selection-menu-actions';
import { type DatabaseAdapter, type SelectionsApi } from '@databases/selections-api';
import { type ViewChangeType } from '@databases/utils/database/view/view';

import { type ActionBarActions } from '../action-bar-portal-state';

interface ActionsBuildContext {
  contentId: string;
  selectionsApi: SelectionsApi;
  databaseAdapter: DatabaseAdapter;
  spaceKey: string;
  panelManager: PanelManager;
}

export function buildActionsForSelectionMode(
  mode: 'row' | 'column' | 'cell',
  context: ActionsBuildContext
): ActionBarActions {
  const { contentId, selectionsApi, databaseAdapter, spaceKey, panelManager } = context;

  if (mode === 'row') {
    return buildRowActions({
      contentId,
      selectionsApi,
      view: getCachedViewSnapshotForSelections(),
      databaseAdapter,
      spaceKey,
      panelManager,
    });
  }

  if (mode === 'column') {
    return (setViewChange: (view: ViewChangeType) => void) =>
      buildColumnActions({
        contentId,
        selectionsApi,
        databaseAdapter,
        setViewChange,
        view: getCachedViewSnapshotForSelections(),
      });
  }

  return buildCellActions({
    contentId,
    selectionsApi,
    panelManager,
  });
}
